/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createProblemDetailsFromDiscriminatorValue, createProductAdministrationDtoFromDiscriminatorValue, createValidationProblemDetailsFromDiscriminatorValue, type ProblemDetails, type ProductAdministrationDto, type ValidationProblemDetails } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/v{version}/ProductAdministrations
 */
export interface ProductAdministrationsRequestBuilder extends BaseRequestBuilder<ProductAdministrationsRequestBuilder> {
    /**
     * Query settings:MaxExpansionDepth = 0, MaxSkip = 2147483647, MaxTop = 1000, PageSize = 1000
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ProductAdministrationDto[]>}
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 405 status code
     * @throws {ProblemDetails} error when the service returns a 500 status code
     * @throws {ProblemDetails} error when the service returns a 502 status code
     * @throws {ProblemDetails} error when the service returns a 503 status code
     * @throws {ProblemDetails} error when the service returns a 504 status code
     */
     get(requestConfiguration?: RequestConfiguration<ProductAdministrationsRequestBuilderGetQueryParameters> | undefined) : Promise<ProductAdministrationDto[] | undefined>;
    /**
     * Query settings:MaxExpansionDepth = 0, MaxSkip = 2147483647, MaxTop = 1000, PageSize = 1000
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<ProductAdministrationsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Query settings:MaxExpansionDepth = 0, MaxSkip = 2147483647, MaxTop = 1000, PageSize = 1000
 */
export interface ProductAdministrationsRequestBuilderGetQueryParameters {
    /**
     * Filter the results using OData syntax.
     */
    filter?: string;
    /**
     * Order the results using OData syntax.
     */
    orderby?: string;
    /**
     * Skip the number of results returned.
     */
    skip?: number;
    /**
     * Limit the number of results returned.
     */
    top?: number;
}
/**
 * Uri template for the request builder.
 */
export const ProductAdministrationsRequestBuilderUriTemplate = "{+baseurl}/api/v{version}/ProductAdministrations{?%24filter*,%24orderby*,%24skip*,%24top*}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const ProductAdministrationsRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "filter": "%24filter",
    "orderby": "%24orderby",
    "skip": "%24skip",
    "top": "%24top",
};
/**
 * Metadata for all the requests in the request builder.
 */
export const ProductAdministrationsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ProductAdministrationsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            405: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            502: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            503: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            504: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createProductAdministrationDtoFromDiscriminatorValue,
        queryParametersMapper: ProductAdministrationsRequestBuilderGetQueryParametersMapper,
    },
};
/* tslint:enable */
/* eslint-enable */
